import { useCallback } from 'react';

export const usePrintInvoice = (orderData) => {
    return useCallback(() => {
        if (!orderData) return;

        const mobile = orderData.mobile || '';
        const sendPrice = orderData.send_price || 0;
        const discount = orderData.discount || 0;
        const timeDelivery = orderData.time === 'now' ? 'سریع‌ترین زمان ممکن' : orderData.time;
        const address = orderData.address || '';
        const isInPerson = orderData.sending_method === 'in_person';
        const deliveryLine = isInPerson ? 'حضوری' : address;
        const paymentMethod = orderData.payment_method === 'cash' ? 'پرداخت در محل' : (orderData.payment_method === 'online' ? 'پرداخت آنلاین' : orderData.payment_method);
        const createdTime = orderData.created.replace(' ', ' PM '); // ساده‌سازی فرمت زمان

        let itemsHtml = '';
        orderData.items.forEach(item => {
            const foodLineTotal = Number(item.food_line_total ?? (Number(item.price) * Number(item.quantity)));
            const dishLineTotal = Number(item.dish_line_total ?? 0);
            const dishQuantity = Number(item.dish_quantity ?? 0);

            const hasDish = dishLineTotal > 0;
            itemsHtml += `
        <tr class="food-row${hasDish ? ' food-row--with-dish' : ''}">
          <td class="name">${item.name}</td>
          <td class="count">${item.quantity}</td>
          <td class="price">${foodLineTotal.toLocaleString()}</td>
        </tr>
      `;

            if (hasDish) {
                itemsHtml += `
        <tr class="dish-row">
          <td class="name dish-name">ظرف</td>
          <td class="count">${dishQuantity}</td>
          <td class="price">${dishLineTotal.toLocaleString()}</td>
        </tr>
      `;
            }
        });

        const htmlContent = `
      <!DOCTYPE html>
      <html lang="fa" dir="rtl">
      <head>
        <meta charset="UTF-8">
        <link href="https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;600;900&display=swap" rel="stylesheet">
        <style>
          body {
            font-family: "Vazirmatn", sans-serif;
            width: 8cm;
            margin: 0 auto;
            line-height: 1.6;
            word-wrap: break-word;
          }
          .title {
            text-align: center;
            font-size: 22px;
            font-weight: 900;
            margin-bottom: 12px;
          }
          .header-line {
            font-size: 17px;
            margin-bottom: 4px;
            font-weight: 600;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 12px;
            table-layout: fixed;
          }
          table th, table td {
            border: 1px solid #000;
            padding: 6px;
            font-size: 16px;
            width: 20px;
            word-break: break-word;
          }
          table th {
            background: #eee;
            font-weight: 600;
          }
          td.name {
            font-weight: 900;
            text-align: right;
            font-size: 14px;
          }
          td.count {
            text-align: center !important;
            font-size: 14px;
            font-weight: 700;
          }
          td.price {
            text-align: right;
            width: 90px;
            font-size: 14px;
            font-weight: 700;
          }
          /* ظرف belongs to the food row above — no line between them */
          tr.food-row--with-dish td {
            border-bottom: none;
          }
          tr.dish-row td {
            border-top: none;
          }
          tr.dish-row td.name.dish-name {
            font-weight: 600;
            font-size: 13px;
            padding-top: 0;
          }
          tr.dish-row td.count,
          tr.dish-row td.price {
            font-weight: 600;
            font-size: 13px;
            padding-top: 0;
          }
          .note {
            margin-top: 12px;
            padding: 12px;
            border: 3px solid #000;
            font-size: 15px;
            font-weight: 900;
            text-align: right;
            line-height: 1.8;
            word-break: break-word;
          }
          .totals {
            margin-top: 18px;
            font-size: 17px;
            line-height: 1.8;
          }
        </style>
      </head>
      <body>
        <div class="title">سامانه سفارش اینترنتی غذارسان</div>
        <div class="header-line">${orderData.full_name}</div>
        <div class="header-line">${createdTime}</div>
        ${orderData.showAddress ? `<div class="header-line">${mobile}</div>` : ""}
        ${orderData.showAddress || isInPerson ? `<div class="header-line">${deliveryLine}</div>` : ""}
        <table>
          <thead>
            <tr>
              <th>نام غذا</th>
              <th>تعداد</th>
              <th>قیمت</th>
            </tr>
          </thead>
          <tbody>
            ${itemsHtml}
          </tbody>
        </table>
        ${!!orderData.notes ? `<div class="note">${orderData.notes}</div>` : ""}
        <div class="totals">
          جمع اقلام فاکتور: ${Number(orderData.total_price)?.toLocaleString()} تومان<br>
          تخفیف: ${Number(discount).toLocaleString()} تومان<br>
          هزینه ارسال: ${sendPrice} <br>
          زمان تحویل: ${timeDelivery} <br>
          نحوه پرداخت: ${paymentMethod} <br>
          <strong>مبلغ نهایی: ${Number(orderData.total_amount)?.toLocaleString()} تومان</strong>
        </div>
      </body>
      </html>
    `;

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(htmlContent);
        iframeDoc.close();

        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 10000);
        };
    }, [orderData]);
};